import { useLiquidGlassPress } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { hapticFeedback } from '@tma.js/sdk';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommonIcon } from '../../common/CommonIcon';

export type FocusModeButtonProps = {
    questId: string;
    onPressedChange?: (pressed: boolean) => void;
};

export const FocusModeButton = ({ questId, onPressedChange }: FocusModeButtonProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pressed, onPointerDown, onPointerMove, onPointerUp, onPointerCancel, onClick } = useLiquidGlassPress({
        preventDefault: true,
        onPressedChange,
        onActivate: () => {
            hapticFeedback.impactOccurred.ifAvailable('light');
            navigate(`/focus-mode/${questId}`);
        },
    });

    return (
        <Box
            component="button"
            type="button"
            aria-label={t('quest.focus.startMode')}
            onClick={onClick}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            sx={{
                width: '100%',
                height: '100%',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
                outline: 'none',
                bgcolor: pressed ? 'color-mix(in srgb, var(--tg-theme-text-color) 8%, transparent)' : 'transparent',
                transition: 'background-color 0.12s ease',
            }}
        >
            <CommonIcon color="var(--tgui--button_color)" size={26} icon="timer" type="filled" />
        </Box>
    );
};
